export default "__VITE_ASSET__Mt84MTes__"